import { Button } from '@mui/material'
import { paymentModes } from '../common/paymentsMode'
import { findObjctByValueFromArrayOfObject } from '../common/helper'

export const LrTrackCommonControls = (props) => {
  const { lrInfo, lrStatInfo = false, loginData, roleRights, data } = props
  const { Table = [], Table1 = [] } = roleRights
  const { BookingBranchID = -1, DestinationBranchID = -1 } = lrInfo||{}
  const [{ AllowReprint = 0, AllowAllBranchLRCancel = 0 } = {}] = Table1
  const branchUnatchBooking = AllowAllBranchLRCancel === 1 ? false : ![BookingBranchID, DestinationBranchID].includes(loginData.intBranchID)
  const branchUnatch = ![BookingBranchID, DestinationBranchID].includes(loginData.intBranchID)
  const bookingStatus = lrStatInfo ? lrStatInfo[lrStatInfo.length - 1].TYPE : false
  let key = paymentModes?.filter((val) => val.typeId == Number(lrInfo?.PaymentType))?.[0]?.roleRightsId
  const cancelBookingRights = findObjctByValueFromArrayOfObject(Table, 2, 'BookingRightsID')?.[0]
  const cancelDeliveryRights = findObjctByValueFromArrayOfObject(Table, 10, 'BookingRightsID')?.[0]
  return (
    <>
      <div className="lrt-card-row">
        <div className="" style={{ padding: '8px' }}>
          <Button
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            disabled={bookingStatus !== 'B' || branchUnatchBooking || cancelBookingRights?.Allowed === 0 || cancelBookingRights[key] === 0}
            onClick={data?.bookingCancel}
          >
            Booking Cancel
          </Button>
        </div>
        <div className="" style={{ padding: '8px' }}>
          <Button
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            disabled={bookingStatus !== 'F' || branchUnatch || cancelDeliveryRights?.Allowed === 0 || cancelDeliveryRights[key] === 0}
            onClick={data?.deliveryCancel}
          >
            Delivery Cancel
          </Button>
        </div>
      </div>
      <div className="lrt-card-row">
        <div className="input--wrapper" style={{ padding: '8px' }}>
          <Button
            // id={iid.searchLrButton}
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            disabled={branchUnatch || AllowReprint === 0}
            onClick={data?.bookingReprint}
          >
            Booking Reprint
          </Button>
        </div>
        <div className="input--wrapper" style={{ padding: '8px' }}>
          <Button
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            disabled={bookingStatus !== 'F' || branchUnatch || AllowReprint === 0}
            onClick={data?.deliveryReprint}
          >
            Delivery Reprint
          </Button>
        </div>
      </div>
    </>
  )
}
